import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import wootConstants from 'dashboard/constants/globals';

/**
 * Shared "return the conversation to the AI assistant" logic, used by the
 * conversation header button and the sidebar conversation actions.
 */
export function useReturnToAi() {
  const store = useStore();
  const { t } = useI18n();

  const currentChat = useMapGetter('getSelectedChat');
  const captainAssistant = useMapGetter('getCopilotAssistant');

  const isReturning = ref(false);

  const canReturnToAi = computed(
    () =>
      currentChat.value?.status === wootConstants.STATUS_TYPE.OPEN &&
      !!captainAssistant.value?.id
  );

  const returnToAiLabel = computed(() =>
    t('CONVERSATION.AI_ATTENDING.RETURN_TO_AI', {
      assistantName: captainAssistant.value?.name,
    })
  );

  const returnToAi = async () => {
    if (isReturning.value) return;
    isReturning.value = true;
    try {
      // The backend clears the assignee and posts the handback activity
      // message when a conversation with a Captain inbox goes pending.
      await store.dispatch('toggleStatus', {
        conversationId: currentChat.value.id,
        status: wootConstants.STATUS_TYPE.PENDING,
      });
      useAlert(t('CONVERSATION.AI_ATTENDING.RETURN_SUCCESS'));
    } catch (error) {
      useAlert(t('CONVERSATION.AI_ATTENDING.RETURN_ERROR'));
    } finally {
      isReturning.value = false;
    }
  };

  return { canReturnToAi, isReturning, returnToAi, returnToAiLabel };
}
